// src/features/tidsregistering/services/absences.js
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/tidsregistering/absences';

export const absencesAPI = {
  createAbsence: (data) =>
    apiClient.post(`${BASE}/`, data),

  getAbsence: (absenceId) =>
    apiClient.get(`${BASE}/${absenceId}`),

  listForStaff: (staffMemberId, startDate, endDate) =>
    apiClient.get(`${BASE}/staff/${staffMemberId}`, { params: { start_date: startDate, end_date: endDate } }),

  listForDepartment: (startDate, endDate) =>
    apiClient.get(`${BASE}/department`, { params: { start_date: startDate, end_date: endDate } }),

  approveAbsence: (absenceId, data) =>
    apiClient.post(`${BASE}/${absenceId}/approve`, data),

  rejectAbsence: (absenceId, data) =>
    apiClient.post(`${BASE}/${absenceId}/reject`, data),

  updateAbsenceDates: (absenceId, data) =>
    apiClient.put(`${BASE}/${absenceId}/dates`, data),

  closeOpenEndedAbsence: (absenceId, data) =>
    apiClient.post(`${BASE}/${absenceId}/close`, data),

  deleteAbsence: (absenceId) =>
    apiClient.delete(`${BASE}/${absenceId}`),

  addComment: (absenceId, data) =>
    apiClient.post(`${BASE}/${absenceId}/comments`, data),

  projectAbsence: ({ staffMemberId, registrationCodeId, startDate, endDate, startTime, endTime }) =>
    apiClient.get(`${BASE}/project`, {
      params: {
        staff_member_id: staffMemberId,
        registration_code_id: registrationCodeId,
        start_date: startDate,
        ...(endDate && { end_date: endDate }),
        ...(startTime && { start_time: startTime }),
        ...(endTime && { end_time: endTime }),
      },
    }),
};
